import { useEffect } from 'react';

import { IS_DEVELOPMENT } from 'src/config';

import './styles.css';
import { useUxSignals } from './useUxSignals';

export const UxSignals = () => {
  const { panelId, shouldLoadScript } = useUxSignals();

  useEffect(() => {
    if (shouldLoadScript) {
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://widget.uxsignals.com/embed.js';

      document.body.appendChild(script);

      return () => {
        try {
          document.body.removeChild(script);
        } catch (error) {
          console.error();
        }
      };
    }
  }, [shouldLoadScript]);

  if (!shouldLoadScript) return null;

  return (
    <div
      data-uxsignals-embed={panelId}
      data-uxsignals-mode={IS_DEVELOPMENT ? 'demo' : ''}
      className="uxsignals-embed min-h-48"
    ></div>
  );
};
